let load = require('./helpers/browser/esm-js-loader-shards')(4);
module.exports = (load("fgbVT")).then(() => parcelRequire('1etiB'));